// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body{overflow-x:hidden}#app{position:relative;z-index:0;background:var(--jw-background-color)!important}", ""]);
// Exports
module.exports = exports;
